module.exports = __webpack_public_path__ + "static/ai-cloud-arm-413d1139d12793e2981dab9aca606853.png";